import React, { useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../utils/api";

const RetryPayment = () => {
  const { orderId } = useParams();
  const [loading, setLoading] = useState(false);

  const retryPayment = async () => {
    setLoading(true);

    const res = await api.post("/api/payment/phonepe/retry", {
      orderId,
    });

    window.location.href =
      res.data.data.instrumentResponse.redirectInfo.url;
  };

  return (
    <div className="container py-5 text-center">
      <h3>Payment Failed</h3>
      <p>Please retry to confirm your order.</p>

      <button
        className="btn btn-warning px-4"
        onClick={retryPayment}
        disabled={loading}
      >
        {loading ? "Redirecting..." : "Retry Payment"}
      </button>
    </div>
  );
};

export default RetryPayment;